import { render } from "./current-projects.vue?vue&type=template&id=4526c576&scoped=true"
import script from "./current-projects.vue?vue&type=script&lang=js"
export * from "./current-projects.vue?vue&type=script&lang=js"

import "./current-projects.vue?vue&type=style&index=0&id=4526c576&scoped=true&lang=scss"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4526c576"]])

export default __exports__